import ABCyaPhaser from "@abcya/abcya_phaser";
import Cell from "./Cell";

export const CellGroupEvents = {
  TRANSITION_IN_COMPLETE: "transitionInComplete",
};

const Constants = {
  CELL_SIZE: 60,
  HIT_SIZE: 30,
  IN_DELAY: 100,
  IN_TIME: 100,
  OUT_DELAY: 150,
  OUT_TIME: 200,
};

export default class CellGroup extends Phaser.GameObjects.Container {
  constructor(
    scene,
    cellData,
    activeStateDisplay,
    clearedStateDisplay,
    labelColor,
    isInteractive
  ) {
    super(scene);
    this.emitter = new Phaser.Events.EventEmitter();
    this.cells = [];
    this.flatCellsArray = [];
    const rows = cellData.length;
    const cols = cellData[0].length;
    const cellSize = Constants.CELL_SIZE;
    const totalCellWidth = cellSize * cols;
    const totalCellHeight = cellSize * rows;
    const leftX = totalCellWidth * -0.5 + cellSize * 0.5;
    const topY = totalCellHeight * -0.5 + cellSize * 0.5;
    for (let y = 0; y < rows; y++) {
      this.cells[y] = [];
      for (let x = 0; x < cols; x++) {
        const val = cellData[y][x];
        if (val !== 0) {
          const cell = new Cell(
            this.scene,
            x,
            y,
            val,
            activeStateDisplay,
            clearedStateDisplay,
            labelColor,
            isInteractive
          );
          cell.x = leftX + cellSize * x;
          cell.y = topY + cellSize * y;
          // this.addChild(cell);
          this.add(cell);
          this.cells[y][x] = cell;
          this.flatCellsArray.push(cell);
        } else {
          this.cells[y][x] = null;
        }
      }
    }
  }

  doInTransition(delay) {
    for (let i = 0; i < this.flatCellsArray.length; i++) {
      const cell = this.flatCellsArray[i];
      cell.scaleX = 0;
      cell.scaleY = 0;

      const completeHandler =
        i === this.flatCellsArray.length - 1
          ? () => {
              this.emitter.emit(CellGroupEvents.TRANSITION_IN_COMPLETE);
            }
          : null;

      ABCyaPhaser.Tweens.addTween(
        cell,
        Constants.IN_TIME,
        {
          delay: delay + Constants.IN_DELAY * i,
          scaleX: 1,
          scaleY: 1,
        },
        Phaser.Math.Easing.Circular.In,
        completeHandler
      );
    }
  }

  doOutTransition(delay) {
    for (let i = 0; i < this.flatCellsArray.length; i++) {
      const cell = this.flatCellsArray[i];

      ABCyaPhaser.Tweens.addTween(
        cell,
        Constants.OUT_TIME,
        {
          delay: delay + Constants.IN_DELAY * i,
          alpha: 0,
        },
        Phaser.Math.Easing.Quadratic.Out
      );
      /*
      createjs.Tween.get(cell)
        .wait(delay + Constants.OUT_DELAY * i)
        .to({ alpha: 0 }, Constants.OUT_TIME, createjs.Ease.quadOut);
        */
    }
  }

  checkCollisions(cellGroup, doAddition) {
    const newGroupCells = cellGroup.getAllCells().slice();
    const thisGroupCells = this.flatCellsArray.slice();
    const collisions = [];
    for (let i in newGroupCells) {
      const cell1 = newGroupCells[i];
      for (let n = 0; n < thisGroupCells.length; n++) {
        const cell2 = thisGroupCells[n];
        cell1.globalPos = cell1.getBounds(); // localToGlobal(0, 0);
        cell2.globalPos = cell2.getBounds(); // localToGlobal(0, 0);
        if (
          cell1.globalPos.x > cell2.globalPos.x - Constants.HIT_SIZE &&
          cell1.globalPos.x < cell2.globalPos.x + Constants.HIT_SIZE &&
          cell1.globalPos.y > cell2.globalPos.y - Constants.HIT_SIZE &&
          cell1.globalPos.y < cell2.globalPos.y + Constants.HIT_SIZE
        ) {
          cell2.showHighlight();
          thisGroupCells.splice(n, 1);
          collisions.push({ cell1: cell1, cell2: cell2 });
          if (doAddition) {
            cell2.setValue(cell1.getValue() + cell2.getValue());
            cell2.hideHighlight();
          }
        } else {
          cell2.hideHighlight();
        }
      }
    }
    return collisions;
  }

  getAllCells() {
    return this.flatCellsArray;
  }

  clearOverlays() {
    for (let i = 0; i < this.flatCellsArray.length; i++) {
      this.flatCellsArray[i].hideValueOverlay();
    }
  }
}
